var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGPay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4035 9.08556C17.4035 8.47702 17.3517 7.88906 17.2533 7.32812H9.04346V10.6577H13.7463C13.6499 11.1897 13.4461 11.6968 13.1472 12.1483C12.8482 12.5998 12.4604 12.9865 12.007 13.2849V15.4463H14.8139C16.4575 13.941 17.4035 11.7153 17.4035 9.08556Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.04339 17.5338C11.3935 17.5338 13.3709 16.7683 14.8139 15.4483L12.0069 13.2856C11.2266 13.8079 10.221 14.1128 9.04339 14.1128C6.77351 14.1128 4.84528 12.5921 4.15681 10.5439H1.26575V12.771C1.99101 14.2034 3.10227 15.4073 4.4756 16.2486C5.84893 17.0898 7.43032 17.5352 9.04339 17.5351",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.15683 10.5429C3.79367 9.46942 3.79367 8.30732 4.15683 7.23386V5.00684H1.26578C0.654604 6.20999 0.336746 7.53922 0.337894 8.88708C0.337894 10.283 0.674364 11.6017 1.26578 12.7686L4.15683 10.5416V10.5429Z",
    fill: "#FABB05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.04344 3.66509C10.3272 3.66509 11.4764 4.10252 12.3823 4.96193V4.96322L14.867 2.49561C13.3606 1.10099 11.3936 0.244141 9.04474 0.244141C7.4318 0.243927 5.8505 0.689134 4.47719 1.53011C3.10387 2.37109 1.99253 3.57479 1.26709 5.00696L4.15815 7.23399C4.84662 5.18579 6.77356 3.66509 9.04344 3.66509Z",
    fill: "#E94235"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGPay);
export default __webpack_public_path__ + "static/media/g-pay.3c12499b78eab44984c0ef755bd523c3.svg";
export { ForwardRef as ReactComponent };